import React from 'react';
const CurrCampaignsConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/current-campaigns',
			component: React.lazy(() => import('./CurrentCampaigns'))
		}
	]
};

export default CurrCampaignsConfig;
